export const REQUIRED = 'REQUIRED';
export const EMAIL = 'EMAIL';
export const STRING = 'STRING';
export const INTEGER = 'INTEGER';
export const NUMBER = 'NUMBER';



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/reducerHalpers/validateTypes.js